import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';

import Button from '@prisjakt/ui-button';

export const Edit = styled.div`
  display: flex;
  align-items: flex-end;
  flex-flow: column;
  transition: opacity ease 0.25s;
`;

export const EditButton = styled.button`
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const EditOption = styled.button`
  width: 100%;
  white-space: nowrap;
  cursor: pointer;
  padding: ${layout.spacing.xSmall};

  &:hover {
    background: ${p => p.theme.dropdowns.secondary.hoverBackground};
  }
`;

export const QuantityControls = styled.div`
  display: flex;
  margin-left: ${layout.spacing.xSmall};

  button {
    width: 24px;
    height: 24px;

    ${media.smallOnly`
      width: 32px;
      height: 32px;
    `};
  }
`;

export const QuantityButton = styled(Button)`
  border-radius: 3px;
  background: ${p => p.theme.bg.secondary};

  &:not(:last-of-type) {
    margin-right: 3px;
  }
`;
